//#region src/customer_identifier.ts
var CustomerIdentifier = /* @__PURE__ */ function(CustomerIdentifier) {
	CustomerIdentifier[CustomerIdentifier["GuestName"] = 1] = "GuestName";
	CustomerIdentifier[CustomerIdentifier["TableNumber"] = 2] = "TableNumber";
	CustomerIdentifier[CustomerIdentifier["BiteOrderNumber"] = 3] = "BiteOrderNumber";
	CustomerIdentifier[CustomerIdentifier["PosOrderNumber"] = 4] = "PosOrderNumber";
	CustomerIdentifier[CustomerIdentifier["VehicleDescription"] = 5] = "VehicleDescription";
	CustomerIdentifier[CustomerIdentifier["Address"] = 6] = "Address";
	CustomerIdentifier[CustomerIdentifier["PhoneNumber"] = 7] = "PhoneNumber";
	CustomerIdentifier[CustomerIdentifier["GuestEmail"] = 8] = "GuestEmail";
	return CustomerIdentifier;
}(CustomerIdentifier || {});
//#endregion
export { CustomerIdentifier };

//# sourceMappingURL=customer_identifier.js.map